import { Component, OnInit, inject } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Therapeut} from '../../../therapeut/therapeut';
import {Observable} from 'rxjs';
import {TherapeutService} from '../../../therapeut/therapeut.service';
import {map, mergeMap} from 'rxjs/operators';

@Component({
    templateUrl: './therapeut.page.html',
    styleUrls: ['./therapeut.page.scss'],
    standalone: false
})
export class TherapeutPage implements OnInit {
  private therapeutService = inject(TherapeutService);
  private route = inject(ActivatedRoute);
  private router = inject(Router);

  therapeut$: Observable<Therapeut>;

  ngOnInit(): void {
    this.therapeut$ = this.route.paramMap
      .pipe(
        map(paramMap => paramMap.get('id')),
        mergeMap(id => this.therapeutService.getTherapeutById$(id)),
      );
  }

  onCancelClicked(): void {
    this.navigateToTherapeuten();
  }

  onEditClicked(therapeut: Therapeut): void {
    this.therapeutService.updateTherapeut$(therapeut)
      .subscribe(() => this.navigateToTherapeuten());
  }

  private navigateToTherapeuten(): void {
    this.router.navigateByUrl('/therapeuten');
  }
}
